import { render, staticRenderFns } from "./PolicyPrivacyField.vue?vue&type=template&id=1d641fb6&"
import script from "./PolicyPrivacyField.vue?vue&type=script&lang=js&"
export * from "./PolicyPrivacyField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
